import { integrateMicroservices } from '../helpers/auto-import'

const files = require.context('.', true, /\.js$/);
export default integrateMicroservices(files);
